import axios from 'axios';

const api = axios.create({
  baseURL: 'https://vbot.co.in/api',
  timeout: 60000
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('vflow_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vflow_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
